import React from 'react';
import { Input } from '@thd-olt-component-react/input';
import PropTypes from 'prop-types';
import { phoneRegex } from '@thd-olt-functional/utils';
import constants from '../../constants/constants';

const unformatPhone = (textParam) => {
  let text = textParam;
  if (!text) {
    text = '';
  }
  return text.replace(/\D/g, '');
};

export const phoneValidator = (formattedPhoneNumber) => {
  let phoneNumber = unformatPhone(formattedPhoneNumber);
  return phoneRegex.test(phoneNumber)
    && !phoneNumber.startsWith('0')
    && !phoneNumber.startsWith('1');
};

export const formatPhone = (val) => {
  if (!val) {
    return '';
  }

  let format = unformatPhone(val).match(/(.{0,3})(.{0,3})(.{0,4})/);
  return !format[2] ? format[1] : '(' + format[1] + ') ' + format[2] + (format[3] ? '-' + format[3] : '');
};

export function PhoneFieldFormatter({ callback, value, name }) {

  const handleChange = (evt) => {
    let phoneNumber = unformatPhone(evt);
    if (phoneNumber.startsWith('0') || phoneNumber.startsWith('1')) {
      phoneNumber = phoneNumber.slice(1);
    }
    if (phoneNumber.length > 10) {
      phoneNumber = phoneNumber.slice(0, -1);
    }

    callback(phoneNumber);
    return phoneValidator(phoneNumber);
  };

  return (
    <Input
      name={`phone-${name}`}
      data-testid="phone-input"
      header="Phone Number"
      className="cpa-form-input"
      errorText={constants.PHONE_FIELD_VALIDATOR_ERROR_TEXT}
      value={formatPhone(value)}
      placeholder="(___)___-____"
      onChange={handleChange}
      validation={phoneValidator}
      maxLength="14"
      validateOnBlur
    />
  );
}

PhoneFieldFormatter.propTypes = {
  callback: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  name: PropTypes.string
};

PhoneFieldFormatter.defaultProps = {
  name: 'phone-input'
};
